const NODE_ENV = process.env.NODE_ENV;
// 当前域名
// 默认会取到：xmbe.infypower.com
// 如果域名为非xmbe.infypower.com，那Nginx上要重新配置一个新的nginx文件及证书
const currentDomain = window.location.host;
const currentProtocol = window.location.protocol;

// 默认配置（为英文）
let config = {
  // 默认
  api_base: '',

  // 不需要message提示的接口列表
  noMessageAPIs: [
    '/api/unauth/info',
    '/api/unauth/login',
    '/api/unauth/password/valid',
    '/api/unauth/password/reset',
    '/api/unauth/password/email',
    '/api/auth/sys/dev/basic/vpn/restart',
    '/api/auth/sys/article/detail',
  ],

  // 静态资源地址
  staticURL: `${currentProtocol}//static.${currentDomain}`,
  // 问题地址
  shareURL: `${currentProtocol}//${currentDomain}`,
};

// 默认语言
config.defaultLocale = process.env.VUE_APP_LOCALE || 'zh-CN';

// 本地开发配置
if (NODE_ENV === 'development') {
  config = {
    ...config,
  };
}
export default config;
